import React, { createContext, useContext, useState, useEffect } from 'react';
import english from '../languages/english.json';
import hindi from '../languages/hindi.json';
import bhojpuri from '../languages/bhojpuri.json';

// Create context
const LanguageContext = createContext();

// Language provider
export const LanguageProvider = ({ children }) => {
  const [selectedLanguage, setSelectedLanguage] = useState({ id: 1, name: 'English' });

  // Load from localStorage on initial mount
  useEffect(() => {
    const stored = localStorage.getItem('selectedLanguage');
    if (stored) {
      setSelectedLanguage(JSON.parse(stored));
    }
  }, []);

  // Save to localStorage on change
  useEffect(() => {
    localStorage.setItem('selectedLanguage', JSON.stringify(selectedLanguage));
  }, [selectedLanguage]);

  // Map language ID to language data
  const languageMap = {
    1: english,
    2: hindi,
    3: bhojpuri
  };

  const currentLanguage = languageMap[selectedLanguage.id] || english;

  // Function to get translated text by key
  const t = (key) => currentLanguage[key] || key;

  return (
    <LanguageContext.Provider
      value={{
        selectedLanguage,
        setSelectedLanguage,
        currentLanguage,
        t
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook for easier usage
export const useLanguage = () => useContext(LanguageContext);
